import React from "react";
import IconEnum from "../../../../enums/icon.enum";
import SizeEnum from "../../../../enums/size.enum";
import Action from "../../../action/action";
import IconLibraryEnum from "../../../../enums/icon-library.enum";
import ShadesEnum from "../../../../enums/shades.enum";
import IActionProps from "./actions.props";

const Actions = (props: IActionProps) => {
  const { show, hintCallback, vocabCallback } = props;

  return (
    <>
      {show.Vocab && (
        <Action
          enabled={true}
          priority={ShadesEnum.LIGHT}
          callback={vocabCallback}
          icon={{
            title: "Vocabulary",
            icon: IconEnum.BOOK as any,
            size: SizeEnum.LARGE as any,
            library: IconLibraryEnum.DUOTONE,
            className: "text-primary"
          }}
        />
      )}
      {show.Hint && (
        <Action
          enabled={true}
          priority={ShadesEnum.LIGHT}
          callback={hintCallback}
          icon={{
            title: "Hint",
            icon: IconEnum.LIGHTBULB_ON as any,
            size: SizeEnum.LARGE as any,
            library: IconLibraryEnum.DUOTONE,
            className: "text-primary"
          }}
        />
      )}
    </>
  );
};

export default Actions;
